import { GET_INSTRUMENTS } from "constants/instruments";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INSTRUMENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
